import React, { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material/styles';
import {
  Alert,
  Box,
  IconButton,
  LinearProgress,
  Snackbar,
  Stack,
  Typography,
} from '@mui/material';
import  {
  Close,
} from '@mui/icons-material';

import * as g04docuMaterialApprovalActions from "../../store/g04docuMaterialApproval";
import * as materialApprovalProgressActions from "../../store/materialApprovalProgress";

const theme = createTheme();

let timerId = null;

function LinearProgressWithLabel(props) {
  return (
    // <Box sx={{ display: 'flex', alignItems: 'center', width: '170px' }}>
    //   <Box sx={{ width: '100%', mr: 1 }}>
    //     <LinearProgress variant="determinate" {...props} />
    //   </Box>
    //   <Box sx={{ minWidth: 35 }}>
    //     <Typography variant="body2" sx={{ color: 'white' }}>{`${Math.round(
    //       props.value,
    //     )}%`}</Typography>
    //   </Box>
    // </Box>
    <Stack direction="row" sx={{ display: 'flex', alignItems: 'center' }}>
      {"진행률"}
      <LinearProgress variant="determinate" {...props} sx={{ width: 200, ml: 1, mr: 1 }} />
      <Typography variant="body2" sx={{ color: 'white' }}>{`${Math.round(props.value)}%`}</Typography>
    </Stack>
  );
}

const G04docuMaterialApprovalProgress = ({
}) => {
  const [pageSize, setPageSize] = useState(20);
  const [page, setPage] = useState(0);
  const [completed, setCompleted] = useState(false);

  const sessionUser = useSelector(state => state.session.sessionUser);
  const options = useSelector(state => state.materialApprovalProgress.options);
  const g04docuMaterialApprovalProgress = useSelector((state) => state.g04docuMaterialApproval.g04docuMaterialApprovalProgress);

  // 데이터 관리
  const dispatch = useDispatch();
  
  const selectProgressById = (id, docType) => dispatch(g04docuMaterialApprovalActions.selectProgressById(id, docType))
  const initProgress = () => dispatch(g04docuMaterialApprovalActions.initProgress())

  const selectAll = (queryOptions, docType) => dispatch(g04docuMaterialApprovalActions.selectPaging(queryOptions, docType))
  const selectByGClient = (gclientId, docType, queryPaging) => dispatch(g04docuMaterialApprovalActions.selectByGClient(gclientId, docType, queryPaging))
  const selectG04docuMaterialApprovalById = (id, docType) => dispatch(g04docuMaterialApprovalActions.selectById(id, docType))

  const location = useLocation();

  const queryPaging = useMemo(
    () => ({
      page,
      pageSize,
    }), [page, pageSize]
  );

  useEffect(
    () => {
      if (options?.open) {
        setCompleted(false);
        
        timerId = setTimeout(function select () {
          selectProgressById(options?.values.id, options?.values.docType);
          timerId = setTimeout(select, 3000)
        }, 3000);
      } else {
        initProgress();
    
        if (timerId) {
          clearTimeout(timerId);
        }

        setTimeout(() => setCompleted(false), 2000);
      }
    }, [options]
  )

  useEffect(
    () => {
      if (g04docuMaterialApprovalProgress && g04docuMaterialApprovalProgress.progressRate === 100 && timerId) {
        console.log(options)
        clearTimeout(timerId);

        setTimeout(() => setCompleted(true), 2000);

        if (location.pathname === "/g04docuGenerateFile" || location.pathname === "/gsupplyConfirmGenerateFile") {
          setTimeout(() => selectG04docuMaterialApprovalById(options?.values?.id, options?.values?.docType), 3000);
        } else if (location.pathname === "/g04docuMaterialApproval" || location.pathname === "/gsupplyConfirmGenerateFileList") {
          const { id: gclientId, type } = sessionUser;
          const docType = options?.values?.docType;
          if (type === 'ADMIN') {
            selectAll(queryPaging, docType);
          } else if (type === 'GCLIENT') {
            selectByGClient(gclientId, docType, queryPaging);
          }
        }
      }
    }, [g04docuMaterialApprovalProgress]
  )

  const handleCloseProgressDialog = () => {
    dispatch(materialApprovalProgressActions.showMaterialApprovalProgress({ open: false }));
  }

  return (
    <>
      <ThemeProvider theme={theme}>
        <Snackbar
          open={options?.open}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        >
          <Alert
            // onClose={handleCloseProgressDialog}
            // severity={g04docuMaterialApprovalProgress?.results?.status === 'FAIL' ? "warning" : "info"} // success, info, warning, error
            severity={"info"} // success, info, warning, error
            variant="filled"
            sx={{ width: '380px' }}
            action={
              completed ? (
                <IconButton color="inherit" size="small" onClick={handleCloseProgressDialog}>
                  <Close fontSize="small" />
                </IconButton> 
              ) : (<></>)
            }
          >
            {
              !completed ? (
                <Stack direction="row">
                  <LinearProgressWithLabel value={g04docuMaterialApprovalProgress && g04docuMaterialApprovalProgress.progressRate ? g04docuMaterialApprovalProgress.progressRate : 0} />
                </Stack>
              ) : (
                <Stack direction="row" display="flex" alignItems="top">
                  {
                    g04docuMaterialApprovalProgress?.results?.status === 'SUCCESS' 
                      ? options?.values?.docType === 'MATERIAL_APPROVAL' 
                        ? "자재승인서가 작성되었습니다."
                        : "납품확인서가 작성되었습니다."
                      : options?.values?.docType === 'MATERIAL_APPROVAL'
                        ? "자재승인서 작성 중 오류가 발생했습니다."
                        : "납품확인서 작성 중 오류가 발생했습니다."
                  }
                </Stack>
              )
            }            
          </Alert>
        </Snackbar>
      </ThemeProvider>
    </>
  );
};

export default G04docuMaterialApprovalProgress;
